(function ($) {
  Drupal.behaviors.emailSignupModuleCoresiteV1 = {
    attach: function (context) {
      const templateContainer = $('.js-email-signup-module-coresite', context);

      templateContainer.find('form').once('emailSignupHandler').each(function () {
        const $form = $(this);

        $form.find('.js-email-signup-module-coresite-cta').on('click', function (ctaEvent) {
          ctaEvent.preventDefault();
          const email = $form.find('.js-email-signup-module-coresite-email').val();

          if (!email) {
            templateContainer.find('.js-email-signup-module-coresite-errors').show();

            return;
          }
          const encodedEmail = encodeURIComponent(email);
          const action = $form.attr('action') || 'email-sign-up';
          const targetUrl = action + '?email=' + encodedEmail;

          window.location.href = targetUrl;
        });
      });
    }
  };
})(jQuery);
